import { motion } from "framer-motion";
import { Stagger, staggerItem, Reveal } from "@/components/site/Reveal";
import { Waves, Heart, Users, Flame, Compass, CloudRain, Sparkles, Brain, Leaf } from "lucide-react";
import { renderScriptTitle } from "@/components/site/scriptTitle";

const ICON_MAP = { Waves, Heart, Users, Flame, Compass, CloudRain, Sparkles, Brain, Leaf };

const DEFAULTS = [
  { title: "Ansiedade", desc: "Ferramentas para lidar com a mente acelerada, preocupações e crises de ansiedade.", icon: "Waves" },
  { title: "Autoestima", desc: "Reconstrua uma relação mais gentil e confiante com você mesma(o).", icon: "Heart" },
  { title: "Relacionamentos", desc: "Compreenda seus vínculos, limites e padrões afetivos.", icon: "Users" },
  { title: "Estresse & Burnout", desc: "Recupere energia e equilíbrio diante do esgotamento e da sobrecarga.", icon: "Flame" },
  { title: "Autoconhecimento", desc: "Explore quem você é, seus valores e o caminho que deseja seguir.", icon: "Compass" },
  { title: "Luto & Perdas", desc: "Um acompanhamento respeitoso para atravessar momentos de dor.", icon: "CloudRain" },
];

const DEFAULT_TITLE = "Onde eu posso te *acompanhar*";
const DEFAULT_INTRO = "Cada processo é único. Estas são algumas das demandas que trabalhamos juntas(os) ao longo da psicoterapia.";

export default function Services({ content }) {
  const services = content?.specialties?.length ? content.specialties : DEFAULTS;
  const title = content?.services_title || DEFAULT_TITLE;
  const intro = content?.services_intro || DEFAULT_INTRO;

  return (
    <section id="especialidades" className="relative bg-[#FDFBF7] py-24 sm:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-body text-xs tracking-[0.4em] uppercase text-[#C87A5E]">Especialidades</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl text-[#2C332A] leading-tight text-balance">
            {renderScriptTitle(title, "font-script text-[#5B6E5B] text-5xl sm:text-6xl")}
          </h2>
          <p className="mt-5 font-body text-[#4A5D4E] leading-relaxed">
            {intro}
          </p>
        </Reveal>

        <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, idx) => {
            const Icon = ICON_MAP[s.icon] || Sparkles;
            return (
              <motion.div
                key={`${s.title}-${idx}`}
                variants={staggerItem}
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                className="group relative rounded-2xl bg-white p-8 border border-[#5B6E5B]/10 shadow-[0_8px_32px_rgba(91,110,91,0.06)] transition-shadow duration-500 hover:shadow-[0_18px_48px_rgba(91,110,91,0.14)]"
                data-testid="service-card"
              >
                <div className="grid place-items-center w-14 h-14 rounded-full bg-[#F5F0E6] transition-colors duration-500 group-hover:bg-[#5B6E5B]">
                  <Icon className="w-6 h-6 text-[#5B6E5B] transition-colors duration-500 group-hover:text-[#FDFBF7]" strokeWidth={1.4} />
                </div>
                <h3 className="mt-6 font-display text-2xl text-[#2C332A]">{s.title}</h3>
                <p className="mt-3 font-body text-sm text-[#4A5D4E] leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
